import { SectionHeader, SurfaceCard } from "../components/designSystem";
import MekFundedAccounts from "../components/MekFundedAccounts";

export default function MekFundedAccountsPage({
  mekFundedAccounts = [],
  selectedMekFundedAccount,
  onSelectMekFundedAccount
}) {

  return (
    <div className="space-y-8">

      <SurfaceCard>

        <SectionHeader
          eyebrow="MekFunded"
          title="Connected funded accounts"
          description="Manage your MekFunded accounts, MT5 connection and trade synchronization."
        />

        <div className="mt-6">

          <MekFundedAccounts
            accounts={mekFundedAccounts}
            selectedAccountId={selectedMekFundedAccount}
            onSelect={onSelectMekFundedAccount}
          />

        </div>

      </SurfaceCard>

    </div>
  );
}